const { storeUrl, deepLinkUrl } = __appConfig.app;

interface LinkOptions {
    slug: string;
    term: number;
}

export function generateLink({ slug, term }: LinkOptions) {
    return `<a href="${storeUrl}/skills/${slug}?utm_source=site&utm_medium=badge&utm_campaign=v1&utm_term=d${term}" target="_blank"><img alt="Алиса это умеет" src="https://dialogs.s3.yandex.net/badges/v1-term${term}.svg"/></a>`;
}

export function generateDeepLink(id: string) {
    return `${deepLinkUrl.replace(/\/$/, '')}/${id}`;
}
